import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPanelToggleButton',
  props: {
    direction: {},
    tooltip: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const isHovered = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppTooltip, {
    class: "search-panel-toggle",
    text: props.tooltip
  }, {
    activator: _withCtx(() => [
      _createElementVNode("div", {
        class: "search-panel-toggle__btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click'))),
        onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (isHovered.value = true)),
        onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (isHovered.value = false))
      }, [
        _createVNode(AppIcon, {
          class: _normalizeClass({ 'search-panel-toggle__icon--up': props.direction === 'up' }),
          name: "chevron-down",
          size: "16px",
          color: isHovered.value ? '#499259' : '#979797'
        }, null, 8, ["class", "color"])
      ], 32)
    ]),
    _: 1
  }, 8, ["text"]))
}
}

})